import React from 'react';
import { Link } from 'react-router-dom';
import { useTenant } from '../contexts/TenantContext';

const SpacedRepetitionMotivation: React.FC = () => {
  const { currentTenant } = useTenant();

  return (
    <div className="relative bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-400/30 via-purple-400/30 to-pink-400/30 bg-[length:200%_200%] animate-gradient-x" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white/10 dark:to-gray-800/10" />
      </div>
      <div className="relative">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
          🧠 Supercharge your memory with spaced repetition
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-3">
          Boost your recall before it slips away! 🚀 Study less, remember more.
        </p>
        <p className="text-gray-500 dark:text-gray-400 italic mb-6">
          Tip: Always have short sessions more often than long sessions less often.
        </p>
        <Link
          to={currentTenant ? `/${currentTenant.website_url}/practice` : '/practice'}
          className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-200 shadow-sm hover:shadow-md"
        >
          Start Practicing Now →
        </Link>
      </div>
    </div>
  );
};

export default SpacedRepetitionMotivation;